// Lib
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Components
import StickyButtons from '../../Button/StickyButtons';

import Materials from '../../../pages/Materials';

// Hooks
import useSharedKitProducts from '../../../pages/Kits/hooks/useSharedKitProducts';

// Actions
import { GetSharedKitDetails } from '../../../actions/sharedKits';
import {
  SetSelectingKitProductsProcess,
  CleanNewKitProducts,
  CleanExistingKitProducts,
} from '../../../actions/kits';

// Selectors
import { kitsSelector } from '../../../store/selectors';

// Constants
import { SHARED_KITS_PATH } from '../../../constants/sharedKits';

// Styles
import { useStyles } from './SharedKitMaterialsStyles';

const SharedKitMaterials = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { kitId } = useParams();
  const { classes } = useStyles();
  const { addProducts } = useSharedKitProducts();
  const { isLoading } = useSelector((state) => state);
  const isSearchActive = useSelector((state) => state.isSearchActive);
  const { newKitProducts, existingKitProducts } = useSelector((state) =>
    kitsSelector(state),
  );

  useEffect(() => {
    dispatch(SetSelectingKitProductsProcess(true));

    return () => {
      dispatch(SetSelectingKitProductsProcess(false));
      dispatch(CleanNewKitProducts());
      dispatch(CleanExistingKitProducts());
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(GetSharedKitDetails(kitId));
  }, [dispatch, kitId]);

  const goBack = () => navigate(`${SHARED_KITS_PATH}/${kitId}`);

  const onAccept = () => {
    addProducts([...newKitProducts, ...existingKitProducts]);
    goBack();
  };

  return (
    <Materials onlyContent>
      {!isSearchActive && (
        <StickyButtons
          onReject={goBack}
          onAccept={onAccept}
          loading={isLoading}
          className={classes.stickyButtons}
        />
      )}
    </Materials>
  );
};

export default SharedKitMaterials;
